import { type ReactNode } from 'react';
import { Badge } from '../atoms/Badge';
import { cn } from '../lib/cn';

export interface TimelineItem {
  id: string;
  authorName: string;
  body: ReactNode;
  timestamp: string;
  isInternal?: boolean;
  isSystem?: boolean;
}

export interface TimelineProps {
  items: TimelineItem[];
  className?: string;
}

export function Timeline({ items, className }: TimelineProps) {
  if (items.length === 0) return null;

  return (
    <ul className={cn('space-y-3', className)}>
      {items.map((item, i) => (
        <li
          key={item.id}
          className={cn(
            'list-stagger rounded-lg border p-3 motion-reduce:animate-none motion-reduce:opacity-100',
            item.isSystem
              ? 'border-dashed border-neutral-300 bg-neutral-50/80 dark:border-neutral-700 dark:bg-neutral-950/80'
              : 'border-neutral-100 bg-neutral-50 dark:border-neutral-800 dark:bg-neutral-950',
          )}
          style={{ animationDelay: `${i * 50}ms` }}
        >
          <div className="flex items-center justify-between text-xs text-neutral-500 dark:text-neutral-400">
            <span className="font-semibold text-yhelp-black dark:text-white">
              {item.authorName}
            </span>
            <time className="font-mono">{item.timestamp}</time>
          </div>
          {item.isInternal ? (
            <Badge variant="neutral" className="mt-1">
              interno
            </Badge>
          ) : null}
          <div className="mt-2 text-sm text-neutral-800 dark:text-neutral-200">{item.body}</div>
        </li>
      ))}
    </ul>
  );
}
